import { supportedLangs, type SupportedLanguage } from "@shared/i18n";

export function resolveLang(value?: string | null): SupportedLanguage {
  const candidate = (value ?? "en").split("-")[0]?.toLowerCase();
  return supportedLangs.includes(candidate as SupportedLanguage)
    ? (candidate as SupportedLanguage)
    : "en";
}

export function localizedRoot(lang?: string | null): string {
  return `/${resolveLang(lang)}`;
}

export function localizedHref(path: string, lang?: string | null): string {
  if (!path || path.startsWith("#") || /^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const firstSegment = normalizedPath.split("/")[1];
  if (supportedLangs.includes(firstSegment as SupportedLanguage)) {
    return normalizedPath;
  }

  if (normalizedPath === "/") {
    return localizedRoot(lang);
  }

  return `${localizedRoot(lang)}${normalizedPath}`;
}
